// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608060026/js/" + chunkId + "." + {"44":"c53a3b5a","225":"b53ae2bf","481":"22fd2657","486":"93acdf33","770":"f8ba87cd"}[chunkId] + ".0.7805689953643143.chunk.js";
};